import { todayTimeline } from "@/mocks/gossipData";
import Reveal from "./Reveal";

const tagStyle: Record<string, string> = {
  速递: "bg-secondary-100 text-secondary-700",
  新瓜: "bg-accent-100 text-accent-700",
  花絮: "bg-primary-100 text-primary-700",
  实锤: "bg-foreground-950/5 text-foreground-700",
  首发: "bg-primary-100 text-primary-700",
  热瓜: "bg-primary-50 text-primary-700",
};

export default function TodayTimeline() {
  return (
    <section id="today" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
                <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary-500" />
                最全黑料今日 · 逐条可回看
              </p>
              <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-foreground-950 md:text-[28px]">
                今日更新 · 全天滚动放送
              </h2>
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
                从清晨到深夜，新瓜按时间轴一条条排好。想补漏就往下滑，刷新列表从不缺席。
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal className="mt-8">
          <div className="relative ml-2 border-l border-background-300 pl-6 md:ml-4 md:pl-8">
            {todayTimeline.map((item, i) => (
              <div key={item.time} className="relative pb-6 last:pb-0">
                <span className="absolute -left-[31px] top-1 h-3 w-3 rounded-full border-2 border-background-50 bg-accent-500 md:-left-[39px]" />
                <a href="#today" className="group block">
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                    <span className="font-mono text-xs font-bold text-foreground-500">{item.time}</span>
                    <span
                      className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${tagStyle[item.tag] || tagStyle["新瓜"]}`}
                    >
                      {item.tag}
                    </span>
                    <span className="flex items-center gap-1 text-[11px] text-foreground-500">
                      <i className="ri-chat-3-fill text-accent-600" />
                      {item.comments.toLocaleString()} 人聊
                    </span>
                  </div>
                  <h3 className="mt-1.5 text-[15px] font-bold leading-snug text-foreground-950 group-hover:text-primary-600">
                    {item.title}
                  </h3>
                </a>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}